"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FastTrack = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FastTrack = function FastTrack(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.027 4.429c.938 0 1.699-.768 1.699-1.715 0-.946-.761-1.714-1.7-1.714-.938 0-1.699.768-1.699 1.714 0 .947.761 1.715 1.7 1.715zm-3.406.727a3.08 3.08 0 00-2.33.464l-1.235.831a.704.704 0 01-.981-.198.718.718 0 01.196-.99l1.235-.831A4.486 4.486 0 019.9 3.755a3.972 3.972 0 012.476 1.632l1.02 1.47h1.897c.391 0 .708.32.708.714a.711.711 0 01-.708.715h-2.265a.706.706 0 01-.58-.305l-.64-.922-1.32 2.662 1.564 1.29a.72.72 0 01.22.817l-1.416 3.714a.709.709 0 01-.914.41.716.716 0 01-.407-.923l1.208-3.169-2.32-1.49-.773.78a4.658 4.658 0 01-2.594 1.326l-2.399.373a.709.709 0 01-.807-.598.713.713 0 01.592-.814l2.005-.311a3.253 3.253 0 002.174-1.37L9.768 5.19a2.538 2.538 0 00-.147-.034z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7 7.857c0-.316.253-.571.565-.571h3.116c.312 0 .566.255.566.571a.569.569 0 01-.566.571H2.265a.569.569 0 01-.566-.571zM.566 9A.569.569 0 000 9.57a.57.57 0 00.566.572h3.115a.569.569 0 00.567-.572A.569.569 0 003.68 9H.566z",
    fill: "currentColor"
  }));
};

exports.FastTrack = FastTrack;
var _default = FastTrack;
exports.default = _default;